module.exports = __webpack_public_path__ + "static/media/aviation-dashboard-logo-text.dabbc202.png";